/** Small deterministic string hash, used to derive a stable fallback gradient. */
function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

/**
 * The generated cover for a title, derived from its id so the same movie always
 * gets the same colours. Used by the poster and, until the viewer has agreed to
 * load from YouTube, as the trailer's preview surface.
 */
export function coverGradient(id: string): string {
  const hue = hashString(id) % 360;
  const hue2 = (hue + 40) % 360;
  return `linear-gradient(160deg, hsl(${hue} 55% 32%), hsl(${hue2} 60% 18%))`;
}
